import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.modal};
    /* top: 49.5%;
    left: 49.5%; */
    top: 50%;
    left: 50%;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-width: 280px;
    max-width: 314px;
    max-height: 80%;
    overflow: hidden;
    transform: translate(-50%, -50%) translate(-0.5px, -0.5px);
    border-radius: 4px;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_light_5_alpha};
    will-change: translate;
    backdrop-filter: blur(50px);
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 8px 12px;
  gap: 8px;
`;

export const TitleBox = styled.div`
  ${({ theme }) => css`
    padding: 0 16px;
  `}
`;

export const Title = styled.strong`
  ${({ theme }) => css`
    ${theme.fontStyle.text.body18_bold}
    color: ${theme.content.content_light_1};
  `}
`;

export const OptionList = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Checked = styled.div<{ checked: boolean }>`
  ${({ theme, checked }) => css`
    position: relative;
    width: 44px;
    height: 44px;

    &::after {
      content: '';
      display: flex;
      position: relative;
      top: 50%;
      left: 50%;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      transform: translate(-50%, -50%);
      border: 1px solid
        ${checked
          ? theme.content.content_light_1
          : theme.content.content_light_5};
      border-radius: 50%;
    }

    ${checked &&
    css`
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 12px;
        height: 12px;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        background: ${theme.content.content_light_1};
      }
    `}
  `}
`;

export const Options = styled.ul`
  ${({ theme }) => css`
    display: block;
    max-height: 80%;
    overflow-y: auto;
  `}
`;

export const Option = styled.li`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 60px;
    padding: 12px 0;
    border-bottom: 1px solid ${theme.backgroundColor.modal_border};
    cursor: pointer;

    &:last-of-type {
      border-bottom: none;
    }
  `}
`;

export const Background = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.background};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: ${theme.backgroundColor.bg_dark_5_alpha};
  `}
`;
